import { ACTIONS_SET, ACTION_ADDED, ACTION_EDITED, ACTION_DELETED } from 'src/app/redux/redux-types';
import { reduxActionTypes } from 'src/types';

export const actionDefaultState: reduxActionTypes.StateType = {
  actionList: [],
};

export const actionReducer = (
  state = actionDefaultState,
  action: reduxActionTypes.ActionType,
): reduxActionTypes.StateType => {
  switch (action.type) {
    case ACTIONS_SET:
      return {
        ...state,
        actionList: action.payload,
      };
    case ACTION_ADDED:
      // eslint-disable-next-line no-case-declarations
      const exists = state.actionList.some((item) => item.id === action.payload.id);
      if (exists) {
        return state;
      }
      return {
        ...state,
        actionList: [action.payload, ...state.actionList],
      };
    case ACTION_EDITED:
      // eslint-disable-next-line no-case-declarations
      const updateIndex = state.actionList.findIndex((obj) => obj.id === action.payload.id);
      return {
        ...state,
        actionList: [
          ...state.actionList.slice(0, updateIndex),
          action.payload,
          ...state.actionList.slice(updateIndex + 1),
        ],
      };
    case ACTION_DELETED:
      return {
        ...state,
        actionList: state.actionList.filter((o) => o.id !== action.payload),
      };
    default:
      return state;
  }
};
